




import { createApp } from 'domainConnectApp/vue3'
import Modal from 'domainConnectApp/Modal';
import { useEmitter } from '../../composition/useEmitter'
import { defineComponent } from '@vue/composition-api'
import { useAppContext } from '../../composition/useAppContext'

let domainConnectModalComponent: any = {}
export default defineComponent({
  watch: {
    '$route': function (id) {
      this.mountDomainConnectModal()
    },
  },
  mounted() {
    this.mountDomainConnectModal()
  },
  methods: {
    async mountDomainConnectModal() {
      if (domainConnectModalComponent.unmount) domainConnectModalComponent?.unmount()
      const route = this.$route
      const router = this.$router
      const emitter = useEmitter()
      const user = this.$store.getters['user/get']
      const store = this.$store
      const userSpecificLanguage = store?.state?.user?.user?.platformLanguage
      const locationSpecificLanguage =
        store?.state?.locations?.currentLocation?.locale_settings?.platform
      const locale = userSpecificLanguage || locationSpecificLanguage || 'en_US'

      const { mountAppContext } = useAppContext()
      domainConnectModalComponent = createApp(Modal, {
        route,
        router,
        emitter,
        user,
        store,
        locale
      });
      mountAppContext({ domainConnectApp: domainConnectModalComponent })
      domainConnectModalComponent.mount(`#domain-connect-modals`);
    },
  }
})
